<!-- Filter Chips Display -->
<div class="filter-chips-container" *ngIf="activeFilterChipsWithValues.length > 0">
    <div class="filter-chips">
        <span class="filter-chip" *ngFor="let chip of activeFilterChipsWithValues">
            <span class="chip-label">{{chip.label}}:</span>
            <span class="chip-value">{{chip.value}}</span>
            <button class="chip-remove" (click)="onClearFilterChip(chip)">
                <i class="fas fa-times"></i>
            </button>
        </span>
        <button class="clear-all-filters" (click)="onClearAllFilters()">
            <i class="fas fa-times"></i> Clear All
        </button>
    </div>
</div>

<!-- Filter Panel -->
<div class="filter-panel" *ngIf="showFilters">
    <div class="filter-header">
        <h3>Advanced Filters</h3>
        <button class="close-filters" (click)="onToggleFilters()">
            <i class="fas fa-times"></i>
        </button>
    </div>

    <div class="filter-sections">
        <!-- Basic Information Section -->
        <div class="filter-section basic-section">
            <div class="section-header" (click)="onToggleFilterSection('basic')">
                <h4><i class="fas fa-user"></i> Basic Information</h4>
                <i class="fas fa-chevron-down" [class.rotated]="activeFilterSection === 'basic'"></i>
            </div>
            <div class="section-content" [class.expanded]="activeFilterSection === 'basic'">
                <div class="filter-row">
                    <div class="filter-group">
                        <label>Religion</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('religion')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('religion', religionOptions)}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['religion']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['religion']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of religionOptions">
                                    <input type="checkbox" [id]="'religion-' + option"
                                        [checked]="isSelected('religion', option)"
                                        (change)="onUpdateMultiSelect('religion', option, $event)">
                                    <label [for]="'religion-' + option">{{option}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-group">
                        <label>Age Range</label>
                        <div class="range-inputs">
                            <input #minAge type="number" placeholder="Min" min="18" max="100"
                                [value]="selectedFilters.ageMin">
                            <span>-</span>
                            <input #maxAge type="number" placeholder="Max" min="18" max="100"
                                [value]="selectedFilters.ageMax">
                            <button class="btn-apply-range"
                                (click)="onApplyAgeRangeFilter(minAge.value, maxAge.value)">Add</button>
                        </div>
                    </div>
                </div>

                <div class="filter-row">
                    <div class="filter-group">
                        <label>Nationality</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('nationality')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('nationality',
                                    nationalityOptions)}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['nationality']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['nationality']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of nationalityOptions">
                                    <input type="checkbox" [id]="'nationality-' + option"
                                        [checked]="isSelected('nationality', option)"
                                        (change)="onUpdateMultiSelect('nationality', option, $event)">
                                    <label [for]="'nationality-' + option">{{option}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-group">
                        <label>Marital Status</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('maritalStatus')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('maritalStatus',
                                    maritalStatusOptions)}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['maritalStatus']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['maritalStatus']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of maritalStatusOptions">
                                    <input type="checkbox" [id]="'maritalStatus-' + option"
                                        [checked]="isSelected('maritalStatus', option)"
                                        (change)="onUpdateMultiSelect('maritalStatus', option, $event)">
                                    <label [for]="'maritalStatus-' + option">{{option}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-row">
                    <div class="filter-group">
                        <label>Gender</label>
                        <select (change)="onUpdateSingleSelect('gender', $event)" [value]="selectedFilters.gender">
                            <option value="">Select Gender</option>
                            <option *ngFor="let option of genderOptions" [value]="option">{{option}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <!-- Personality & Lifestyle Section -->
        <div class="filter-section lifestyle-section">
            <div class="section-header" (click)="onToggleFilterSection('lifestyle')">
                <h4><i class="fas fa-heart"></i> Personality & Lifestyle</h4>
                <i class="fas fa-chevron-down" [class.rotated]="activeFilterSection === 'lifestyle'"></i>
            </div>
            <div class="section-content" [class.expanded]="activeFilterSection === 'lifestyle'">
                <div class="filter-row">
                    <div class="filter-group">
                        <label>Interests</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('interest')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('interest', interestOptions,
                                    'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['interest']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['interest']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of interestOptions">
                                    <input type="checkbox" [id]="'interest-' + option.id"
                                        [checked]="isSelected('interest', option.id)"
                                        (change)="onUpdateMultiSelect('interest', option.id, $event)">
                                    <label [for]="'interest-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-group">
                        <label>Values</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('values')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('values', valueOptions, 'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['values']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['values']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of valueOptions">
                                    <input type="checkbox" [id]="'values-' + option.id"
                                        [checked]="isSelected('values', option.id)"
                                        (change)="onUpdateMultiSelect('values', option.id, $event)">
                                    <label [for]="'values-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-row">
                    <div class="filter-group">
                        <label>Alcohol Consumption</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('alcoholConsumption')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('alcoholConsumption',
                                    alcoholConsumptionOptions, 'name')}}</span>
                                <i class="fas fa-chevron-down"
                                    [class.rotated]="openDropdowns['alcoholConsumption']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['alcoholConsumption']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of alcoholConsumptionOptions">
                                    <input type="checkbox" [id]="'alcoholConsumption-' + option.id"
                                        [checked]="isSelected('alcoholConsumption', option.id)"
                                        (change)="onUpdateMultiSelect('alcoholConsumption', option.id, $event)">
                                    <label [for]="'alcoholConsumption-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-group">
                        <label>Smoking</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('smoker')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('smoker', smokingOptions, 'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['smoker']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['smoker']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of smokingOptions">
                                    <input type="checkbox" [id]="'smoker-' + option.id"
                                        [checked]="isSelected('smoker', option.id)"
                                        (change)="onUpdateMultiSelect('smoker', option.id, $event)">
                                    <label [for]="'smoker-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-row">
                    <div class="filter-group">
                        <label>Children</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('children')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('children', childrenOptions)}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['children']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['children']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of childrenOptions">
                                    <input type="checkbox" [id]="'children-' + option"
                                        [checked]="isSelected('children', option)"
                                        (change)="onUpdateMultiSelect('children', option, $event)">
                                    <label [for]="'children-' + option">{{option}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-group">
                        <label>Wakeup Time</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('iUsuallyWakeUpAt')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('iUsuallyWakeUpAt', wakeupAtOptions,
                                    'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['iUsuallyWakeUpAt']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['iUsuallyWakeUpAt']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of wakeupAtOptions">
                                    <input type="checkbox" [id]="'iUsuallyWakeUpAt-' + option.id"
                                        [checked]="isSelected('iUsuallyWakeUpAt', option.id)"
                                        (change)="onUpdateMultiSelect('iUsuallyWakeUpAt', option.id, $event)">
                                    <label [for]="'iUsuallyWakeUpAt-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-row">
                    <div class="filter-group">
                        <label>Hobbies</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('hobbies')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('hobbies', hobbiesOptions,
                                    'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['hobbies']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['hobbies']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of hobbiesOptions">
                                    <input type="checkbox" [id]="'hobbies-' + option.id"
                                        [checked]="isSelected('hobbies', option.id)"
                                        (change)="onUpdateMultiSelect('hobbies', option.id, $event)">
                                    <label [for]="'hobbies-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-group">
                        <label>Fitness</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('fitness')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('fitness', fitnessOptions,
                                    'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['fitness']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['fitness']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of fitnessOptions">
                                    <input type="checkbox" [id]="'fitness-' + option.id"
                                        [checked]="isSelected('fitness', option.id)"
                                        (change)="onUpdateMultiSelect('fitness', option.id, $event)">
                                    <label [for]="'fitness-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-row">
                    <div class="filter-group">
                        <label>Personality</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('personality')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('personality', personalityOptions,
                                    'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['personality']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['personality']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of personalityOptions">
                                    <input type="checkbox" [id]="'personality-' + option.id"
                                        [checked]="isSelected('personality', option.id)"
                                        (change)="onUpdateMultiSelect('personality', option.id, $event)">
                                    <label [for]="'personality-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-group">
                        <label>Life Goals</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('lifeGoals')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('lifeGoals', lifeGoalsOptions,
                                    'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['lifeGoals']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['lifeGoals']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of lifeGoalsOptions">
                                    <input type="checkbox" [id]="'lifeGoals-' + option.id"
                                        [checked]="isSelected('lifeGoals', option.id)"
                                        (change)="onUpdateMultiSelect('lifeGoals', option.id, $event)">
                                    <label [for]="'lifeGoals-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-row" style="padding-bottom: 150px;">
                    <div class="filter-group">
                        <label>Maxion Goals</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('maxionGoals')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('maxionGoals', maxionGoalsOptions,
                                    'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['maxionGoals']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['maxionGoals']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of maxionGoalsOptions">
                                    <input type="checkbox" [id]="'maxionGoals-' + option.id"
                                        [checked]="isSelected('maxionGoals', option.id)"
                                        (change)="onUpdateMultiSelect('maxionGoals', option.id, $event)">
                                    <label [for]="'maxionGoals-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-group">
                        <label>Meet Vibes</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('meetVibes')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('meetVibes', meetVibesOptions,
                                    'name')}}</span>
                                <i class="fas fa-chevron-down" [class.rotated]="openDropdowns['meetVibes']"></i>
                            </div>
                            <div class="dropdown-content" [class.show]="openDropdowns['meetVibes']"
                                (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of meetVibesOptions">
                                    <input type="checkbox" [id]="'meetVibes-' + option.id"
                                        [checked]="isSelected('meetVibes', option.id)"
                                        (change)="onUpdateMultiSelect('meetVibes', option.id, $event)">
                                    <label [for]="'meetVibes-' + option.id">{{option.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Signup & Profile Status Section -->
        <div class="filter-section signup-section">
            <div class="section-header" (click)="onToggleFilterSection('profile')">
                <h4><i class="fas fa-clipboard-check"></i> Signup & Profile Status</h4>
                <i class="fas fa-chevron-down" [class.rotated]="activeFilterSection === 'profile'"></i>
            </div>
            <div class="section-content" [class.expanded]="activeFilterSection === 'profile'">

                <div class="filter-row">
                    <div class="filter-group">
                        <label>Passport Verified</label>
                        <select (change)="onUpdateSingleSelect('passportVerified', $event)"
                            [value]="selectedFilters.passportVerified">
                            <option value="">Select Option</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>

                    <div class="filter-group">
                        <label>Subscription Status</label>
                        <div class="multiselect-dropdown" (click)="toggleDropdown('subscriptionStatus')">
                            <div class="dropdown-header">
                                <span class="selected-text">{{getSelectedText('subscriptionStatus',
                                    subscriptionStatusOptions)}}</span>
                                <i class="fas fa-chevron-down"
                                    [class.rotated]="openDropdowns['subscriptionStatus']"></i>
                            </div>
                            <div class="dropdown-content subscriptionDropdown"
                                [class.show]="openDropdowns['subscriptionStatus']" (click)="$event.stopPropagation()">
                                <div class="checkbox-item" *ngFor="let option of subscriptionStatusOptions">
                                    <input type="checkbox" [id]="'subscriptionStatus-' + option"
                                        [checked]="isSelected('subscriptionStatus', option)"
                                        (change)="onUpdateMultiSelect('subscriptionStatus', option, $event)">
                                    <label [for]="'subscriptionStatus-' + option">{{option}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-row">
                    <div class="filter-group">
                        <label>Signup Step No</label>
                        <div class="range-inputs">
                            <input #minSignupStep type="number" placeholder="Min" min="0" max="10"
                                [value]="selectedFilters.signupStepNo.min">
                            <span>-</span>
                            <input #maxSignupStep type="number" placeholder="Max" min="0" max="10"
                                [value]="selectedFilters.signupStepNo.max">
                            <button class="btn-apply-range"
                                (click)="onApplyStepRangeFilter('signup', minSignupStep.value, maxSignupStep.value)">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Activity-Based Filters Section -->
        <div class="filter-section">
            <div class="section-header" (click)="onToggleFilterSection('activity')">
                <h4><i class="fas fa-chart-line"></i> Activity-Based Filters</h4>
                <i class="fas fa-chevron-down" [class.rotated]="activeFilterSection === 'activity'"></i>
            </div>
            <div class="section-content" [class.expanded]="activeFilterSection === 'activity'">
                <div class="filter-row">
                    <div class="filter-group">
                        <label>No Matches in Last N Days</label>
                        <input type="number" placeholder="Enter days" min="0" max="365"
                            [value]="selectedFilters.noMatchesInLastDays"
                            (input)="onUpdateNumberInput('noMatchesInLastDays', $event)">
                    </div>
                    <div class="filter-group" *ngIf="showNumberOfLikes">
                        <label>Number of Likes</label>
                        <input type="number" placeholder="Enter number of likes" min="0"
                            [value]="selectedFilters.numberOfLikes || ''"
                            (input)="onUpdateNumberInput('numberOfLikes', $event)">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="filter-actions">
        <button class="btn btn-secondary" (click)="onClearAllFilters()">Clear All</button>
        <button class="btn btn-primary" (click)="onApplyFilters()">Apply Filters</button>
    </div>
</div>